import { createRequestTypes } from 'common/websocket-redux';

export const GET_USER_PAYMENT_CREDENTIALS = createRequestTypes(
  'resources/GET_USER_PAYMENT_CREDENTIALS',
);

export const getUserPaymentCredentials = () => ({
  type: GET_USER_PAYMENT_CREDENTIALS.BASE,
});
